<template>
  <div class="mainSearchContent">
    <div class="topImg">
      <div class="contentBox">
        <img class="logo" src="@/assets/images/footballAssociation.png" alt />
        <img class="title" src="@/assets/images/title_search.png" alt />
      </div>
    </div>
    <div class="content" >
      <div class="level grade_d" @click="jumpSearch('d')">
        <img src="@/assets/images/grade_d.png" alt class="icon" />
        <p>D级</p>
      </div>
    </div>
    <div class="content">
      <div class="level grade_abc" @click="jumpSearch('pabc')">
        <img src="@/assets/images/grade_abc.png" alt class="icon" />
        <p>职业/A/B/C级</p>
      </div>
    </div>
    <div class="content">
      <div class="level grade_g" @click="jumpSearch('g')">
        <img src="@/assets/images/grade_g.png" alt class="icon" />
        <p>岗位培训</p>
      </div>
    </div>

    <div class="about">
      <a target="_blank" href="http://www.thecfa.cn/hitz/20190909/27995.html">
        <span class="title">《中国足协关于发放亚足联/中国足协教练员等级证书和执照的通知》</span>
        <span class="look">查看</span>
        <img src="@/assets/images/eye.png" alt class="eyeImg" />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    jumpSearch(type) {
      let router = "";
      if (type === "d") {
        router = "search-grade-d";
      } else if (type === "pabc") {
        router = "search-grade-pabc";
      } else {
        router = "search-grade-g";
      }
      this.$router.push(router);
    }
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable';

html, body {
  height: 100%;
  width: 100%;
}

#app {
  min-width: unset;
  min-height: unset;
  height: 100%;
  width: 100%;
}

.mainSearchContent {
  width: 100%;
  height: 100%;
  padding: 0 5%;

  .topImg {
    width: 100%;
    height: 14%;
    padding: 2% 0;

    // /* height: 17%; */
    .contentBox {
      height: 100%;
      display: flex;
      align-items: center;

      .logo {
        height: 100%;
        width: 20%;
      }

      .title {
        width: 78%;
        height: 100%;
        margin-left: 2%;
      }
    }
  }

  .content {
    padding-top: 5%;
    height: 22%;

    .level {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: $color_white;
      // margin-top: 5%;
      height: 100%;
      border-radius: 4px;
      background: linear-gradient(to right, rgb(49, 144, 95) 50%, rgb(53, 151, 102) 0);
      background-size: 3% 100%;

      .icon {
        width: 30px;
        // margin-bottom: 5px;
      }
    }
  }

  .about {
    cursor: pointer;
    padding-top: 3%;
    font-size 12px
    height: 10%;
    text-align: center;

    .title {
      color: rgb(109, 100, 117);
    }

    .look {
      color: $color_suc;
    }

    .eyeImg {
      width: 20px;
    }
  }
}

@media screen and (min-width: 700px) and (max-width: 1024px) {
  .mainSearchContent {
    .level {
      font-size: 20px;

      .icon {
        width: 40px;
        margin-bottom: 5px;
      }
    }

    .about {
      
      font-size: 20px;

      .eyeImg {
        width: 25px;
      }
    }
  }
}

@media screen and (min-width: 1024px) and (max-width: 1600px) {
  .mainSearchContent {
    .level {
      font-size: 25px;
    }

    .about {
      
      font-size: 25px;

      .eyeImg {
        width: 30px;
      }
    }
  }
}
</style>